module.exports = __webpack_public_path__ + "static/img/kmR22.8a16b83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/internationalBrand/kmR22.jpg
// module id = MNyV
// module chunks = 1